import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService, ResponseObject } from '../auth.service';
import { UsersService } from '../users.service';

@Injectable({
  providedIn: 'root'
})
export class InitializationService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService,
    private userService: UsersService
  ) { }

  public initializeApp(): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      // Helper to complete initialization and notify app
      const completeInit = (result?: string) => {
        this.authService.setAuthStateReady();
        resolve(result);
      };

      // Skip initialization on server side
      if (!isPlatformBrowser(this.platformId)) {
        completeInit(undefined);
        return;
      }

      const isAuthenticated = this.authService.isAuthenticated();
      const isOnFreeTrial: boolean = this.authService.isOnFreetrial();

      //if the user is authenticated and is on free trial, check if the trial has expired
      if (isAuthenticated && isOnFreeTrial) {
        var trialExpiryDate: Date | null = this.authService.getTrailExpiryDate();
        if (trialExpiryDate != null) {
          const expiryDate = new Date(trialExpiryDate);
          const currentDate = new Date();
          if (currentDate < expiryDate) {
            completeInit('Valid trial');
          } else {
            this.userService.endFreeTrail().subscribe((responce: ResponseObject) => {
              if (responce.Success) {
                this.authService.setAccessToken(responce.ResponseData);
                // Instead of full page reload, just resolve and let the app handle the state change
                // The app component will pick up the new token state
              }
              completeInit('Successfully downgraded to a free account');
            }, error => {
              console.error(error);
              this.authService.setAuthStateReady(); // Still mark as ready even on error
              reject('The trial has expired but the application could not downgrade the user to a free account.');
            });
          }
        } else {
          //if the expiry date of the trial is null
          completeInit(undefined);
        }
      } else {
        completeInit(undefined);
      }
    });
  }
}
